<!--
 * @Description: 接收实时监控的数据并转换成需要的数据传给displayPie.vue
 * @Date: 2020-07-22 17:39:36
 * @Author: jawnwa22
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-08-28 16:46:44
--> 
<template>
  <display-ring :graph="graph" :extend="chartExtendRing" :data="chartData" v-if="graph.radio===2"></display-ring>
  <display-pie :graph="graph" :extend="chartExtend" :data="chartData" :nodata="flag" v-else></display-pie>
</template>

<script>
import displayPie from './displayPie.vue';
import displayRing from './dispalyRing.vue';

export default {
  props: {
    graph: {
      type: Object,
      default: () => {},
    },
    realTimeData: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    displayPie,
    displayRing,
  },
  data() {
    return {
      // chartExtend: {
      //     series: {
      //         radius: '50%',
      //         center: ['50%', '50%'],
      //     },
      //     legend: {
      //         show: false,
      //     },
      // },
    };
  },
  created() {},
  computed: {
    // 判断是否有这个变量点，若无则显示暂无数据
    flag() {
      let flag = true;
      this.graph.rules.forEach((item) => {
        if (
          this.realTimeData[item.point.name] ||
          this.realTimeData[item.point.name] === 0
        ) {
          flag = false;
        }
      });
      return flag;
    },
    chartData() {
      let rows = this.graph.rules.map((item) => {
        return {
          name: item.alias ? item.alias : item.point.desc,
          value: this.realTimeData[item.point.name],
        };
      });
      let columns = ['name', 'value'];
      return {
        columns,
        rows,
      };
    },
    chartExtend() {
      return {
        series: {
          radius: '50%',
          center: ['50%', '50%'],
          label: {
            // bleedMargin: 10,
            // position: 'outside',
            formatter: this.getFormatter,
          },
        },
        legend: {
          show: false,
        },
        color: this.computedColorList(),
      };
    },
    chartExtendRing() {
      return {
        series: {
          center: ['50%', '50%'],
          label: {
            // bleedMargin: 10,
            // position: 'outer',
            // alignTo: 'none',
            formatter: this.getFormatter,
          },
        },
        legend: {
          show: false,
        },
        color: this.computedColorList(),
      };
    },
  },
  methods: {
    computedColorList() {
      let colorList = [];
      this.graph.rules.forEach((item) => {
        colorList.push(item.color);
      });
      return colorList;
    },
    getFormatter(e) {
      var newStr = ' ';
      var start, end;
      var name_len = e.name.length; //每个内容名称的长度
      var max_name = 4; //每行最多显示的字数
      var new_row = Math.ceil(name_len / max_name); // 最多能显示几行，向上取整比如2.1就是3行
      if (name_len > max_name) {
        //如果长度大于每行最多显示的字数
        for (var i = 0; i < new_row; i++) {
          //循环次数就是行数
          var old = ''; //每次截取的字符
          start = i * max_name; //截取的起点
          end = start + max_name; //截取的终点
          if (i == new_row - 1) {
            //最后一行就不换行了
            old = e.name.substring(start);
          } else {
            old = e.name.substring(start, end) + '\n';
          }
          newStr += old; //拼接字符串
        }
      } else {
        //如果小于每行最多显示的字数就返回原来的字符串
        newStr = e.name;
      }
      return newStr;
    },
  },
};
</script>